import {
  FormControl,
  MenuItem,
  Select,
  type SelectChangeEvent,
  Stack,
  Typography
} from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { violetVariants } from '@/themes/colors.ts'
import { styled } from '@mui/material/styles'
import { useApplicationLanguages } from '@/hooks/useApplicationLanguages.ts'

const StyledSelect = styled(Select<string>)(({ theme }) => ({
  background: theme.palette.background.default,
  '.MuiOutlinedInput-notchedOutline': { border: 'none' },
  '&.MuiOutlinedInput-root:hover': {
    background: violetVariants['50'],
    color: theme.palette.primary.main,
    '& .MuiSelect-icon': {
      color: theme.palette.primary.main
    }
  },
  '&.Mui-focused': {
    color: theme.palette.primary.main,
    '& .MuiSelect-icon': {
      color: theme.palette.primary.main
    }
  }
}))

export const LanguageSelector = () => {
  const { i18n, t } = useTranslation('_global')
  const languages = useApplicationLanguages()
  const [language, setLanguage] = useState(i18n.resolvedLanguage)

  const handleChange = useCallback((event: SelectChangeEvent) => {
    setLanguage(event.target.value as string)
  }, [])

  useEffect(() => {
    i18n.changeLanguage(language)
  }, [language, i18n])

  return (
    <FormControl size="small" sx={{ py: 0 }}>
      <StyledSelect
        value={language}
        onChange={handleChange}
        displayEmpty
        disableUnderline
      >
        {languages.map(lang => (
          <MenuItem value={lang}>
            <Stack direction="row" gap={1}>
              <Stack direction="column" justifyContent="center">
                <img
                  src={
                    'https://flagcdn.com/w20/' +
                    t(`commons.languages.${lang}.icon`) +
                    '.png'
                  }
                  srcSet={
                    'https://flagcdn.com/w40/' +
                    t(`commons.languages.${lang}.icon`) +
                    '.png 2x'
                  }
                  width="20"
                  height="13"
                  style={{ borderRadius: 2 }}
                />
              </Stack>
              <Typography>{t(`commons.languages.${lang}.label`)}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  )
}
